import React from 'react';
import { FirstLine, LeftDiv, Line, Main, Profile, RightDiv, Row, SecondLine, Square } from './styles';

export default function TeamsLoading() {
  return (
    <Main>
      <Row>
        <LeftDiv>
          <Profile className='loading-animation' />
          <Line>
            <FirstLine className='loading-animation' />
            <SecondLine className='loading-animation' />
          </Line>
        </LeftDiv>
        <RightDiv>
          <Square className='loading-animation' />
        </RightDiv>
      </Row>
      <Row>
        <LeftDiv>
          <Profile className='loading-animation' />
          <Line>
            <FirstLine className='loading-animation' />
            <SecondLine className='loading-animation' />
          </Line>
        </LeftDiv>
        <RightDiv>
          <Square className='loading-animation' />
        </RightDiv>
      </Row>
      <Row>
        <LeftDiv>
          <Profile className='loading-animation' />
          <Line>
            <FirstLine className='loading-animation' />
            <SecondLine className='loading-animation' />
          </Line>
        </LeftDiv>
        <RightDiv>
          <Square className='loading-animation' />
        </RightDiv>
      </Row>
      <Row>
        <LeftDiv>
          <Profile className='loading-animation' />
          <Line>
            <FirstLine className='loading-animation' />
            <SecondLine className='loading-animation' />
          </Line>
        </LeftDiv>
        <RightDiv>
          <Square className='loading-animation' />
        </RightDiv>
      </Row>
      <Row>
        <LeftDiv>
          <Profile className='loading-animation' />
          <Line>
            <FirstLine className='loading-animation' />
            <SecondLine className='loading-animation' />
          </Line>
        </LeftDiv>
        <RightDiv>
          <Square className='loading-animation' />
        </RightDiv>
      </Row>
    </Main>
  );
}
